import React from 'react';

import LoginOverlayButton from '../../../Login/LoginOverlayButton';
import Backdrop from '../../../Modal/Backdrop';
import { ActionType, LocalCart as LocalCartType } from '../../Types';
import CartItem from '../CartItem/CartItem';
import CartNotificationAdd from '../CartNotifications/CartNotificationAdd';
import CartNotificationUpdate from '../CartNotifications/CartNotificationUpdate';
import LocalCartTotal from './LocalCartTotal';

import '../Cart.scss';

interface Props {
    cart: LocalCartType;
    latestAction: ActionType | null;
    hideCart: () => void;
}

const LocalCart: React.FunctionComponent<Props> = (props) => {
    const cart = props.cart;

    const toggleVisibilityClass = () => {
        if (cart.visible) {
            return 'slide-in-cart--visible';
        }

        return '';
    };

    return (
        <>
            <aside className={'slide-in-cart ' + toggleVisibilityClass()}>
                <CartNotificationAdd latestAction={props.latestAction} />
                <CartNotificationUpdate latestAction={props.latestAction} />
                <div className="cart">
                    <button
                        className="slide-in-cart__close-button"
                        onClick={props.hideCart}
                        aria-label="Warenkorb schließen"
                    >
                        <svg className="icon icon--arrow">
                            <use xlinkHref="#icon-arrow" />
                        </svg>
                        Weiter einkaufen
                    </button>
                    {cart.items.length > 0 ? (
                        <>
                            <ul>
                                {cart.items.map((cartItem) => {
                                    return <CartItem item={cartItem} key={cartItem.articleNumber} />;
                                })}
                            </ul>
                            <LocalCartTotal items={cart.items} />
                            <LoginOverlayButton
                                primary={true}
                                onClick={() => {
                                    props.hideCart();
                                }}
                            />
                        </>
                    ) : (
                        <p> Sie haben noch keine Produkte im Warenkorb</p>
                    )}
                </div>
            </aside>
            <Backdrop visible={props.cart.visible} onClick={props.hideCart} />
        </>
    );
};

export default LocalCart;
